import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import stubs from '@/init';
import { watch } from 'vue';

import { businessRoutes, businessMenu } from '@/router/modules';
import lodash from 'lodash';
import CommonStore from '@/store/modules/common';
import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const account = computed(() => stubs.account.account);
watch(account, () => setFirstRouter());

const setFirstRouter = () => {
  const menuMap = lodash.keyBy(
    businessMenu.map((menu) => ({ ...menu, children: [] as any[] })),
    (v) => v.key
  );
  const userBusinessRoutes: any[] = [];
  businessRoutes.forEach((route) => {
    if (true || stubs.account.hasAllPermissions(route.meta.permissionCode)) {
      userBusinessRoutes.push(route);
      (menuMap[route.meta.parentMenuKey]?.children || []).push(route);
    }
  });

  const navSideConfigList = Object.values(menuMap).filter(
    (it) => it.children.length !== 0
  );
  navSideConfigList.sort((a, b) => a.order - b.order);
  const possibleFirstRoute = userBusinessRoutes.find((it) =>
    (it?.path).includes('dataReport')
  );
  const firstRouter = possibleFirstRoute
    ? possibleFirstRoute
    : navSideConfigList.length
    ? navSideConfigList[0].children[0]
    : null;
  stubs.stores.retrieveStore(CommonStore).SET_FIRST_ROUTER(firstRouter);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(zhCn) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})